const RadioSize = {
  Size10: 'size10',
  Size12: 'size12',
};

export default RadioSize;
